/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Docx_TranscriptInputs */



/**
* | output |
* | --- |
* | "DocX Transcript" |
*
* @param {Docx_TranscriptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const docx_transcript = /** @type {((inputs?: Docx_TranscriptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Docx_TranscriptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription DocX")
	if (locale === "de") return /** @type {LocalizedString} */ ("DocX-Transkript")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione DocX")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Транскрипт DocX")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción DocX")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("DocX 文字稿")
	if (locale === "ja") return /** @type {LocalizedString} */ ("DocXトランスクリプト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("DocX प्रतिलेख")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição do DocX")
	return /** @type {LocalizedString} */ ("DocX Transcript")
});